import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';

import { Button, ButtonIcon, Footer } from '@sonyged/ext-proc';

import AppContext from '../../../AppContext';
import Constants from './Constants';

export default class AnalysisContent extends React.Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);
    this.state = {
      iceCtxIndex: props.iceCtxIndex,
    };
  }

  render() {
    return (
      <div className={'proc-ice-field-content analysis'}>
        <div className={'proc-contents padding'}>
          <div className={'proc-outer'}>
            <div className={'proc-inner'}>
              {this._renderHeader()}
              {this._renderContent()}
            </div>
          </div>
        </div>
        {this._renderFooter()}
      </div>
    );
  }

  componentDidMount() {
    this.context.soundController.sePlay('kekkagamen');
  }

  _renderHeader() {
    let iceCtx = this._getIceCtx();
    return (
      <div className={'header'}>
        <div className={'left'}>
          <div className={'weather secondary100-fill-color'}>{Constants.getWetherSvg(iceCtx.weather)}</div>
          <div className={'temperature secondary100-color'}>
            <span className={'proc-huge-font'}>{iceCtx.temperature}</span>
            <span className={'proc-medium-font'}>ど</span>
          </div>
        </div>
        <div className={'center'}>
          <img className={'image'} src={Constants.getStatusWagonIcon(this.props.wagon)} />
        </div>
        <div className={'right'}>
          <img className={'image'} src={Constants.getPlaceIcon(iceCtx.place)} />
          <img className={'image'} src={Constants.getIceImage(iceCtx.ice)} />
        </div>
      </div>
    );
  }

  _renderPreviousButton() {
    if (this.props.onPreviousClick) {
      return (
        <Button.normal onClick={this.props.onPreviousClick}>
          <ButtonIcon.back />
        </Button.normal>
      );
    }
    return <span />;
  }

  _renderNextButton() {
    if (this.props.lastPage) {
      return (
        <Link
          to={{ pathname: '/ice/fields', search: '?skip_intro=true' }}
          className={'proc-button proc-button--attention'}
        >
          しゅうりょう
        </Link>
      );
    }

    if (!this.props.onNextClick) {
      return <span />;
    }

    return <Button.attention onClick={this.props.onNextClick}>つぎへ</Button.attention>;
  }

  _renderFooter() {
    return (
      <Footer.nav className="white-bg-color" navItem={this._renderPreviousButton()}>
        {this._renderNextButton()}
      </Footer.nav>
    );
  }

  _renderContent() {
    return (
      <div className={'analysis-container flex-1 hauto white-bg-color'}>
        <div className={'summary-container'}>
          <div className={'sales'}>
            <div className={'title secondary100-color proc-small-font'}>もらった おかね</div>
            <div className={'gray100-color proc-huge-font result-value'}>
              {`${this._getIceCtx().totalSales}`}
              <span className={'proc-small-font postfix'}>えん</span>
            </div>
          </div>
          <div className={'stock'}>
            <div className={'title secondary100-color proc-small-font'}>うれた かず</div>
            <div className={'gray100-color proc-huge-font result-value'}>
              {this._getIceCtx().totalSalesNum}
              <span className={'proc-small-font postfix'}>こ</span>
            </div>
          </div>
        </div>

        <table className={'proc-table'}>
          <thead>
            <tr>
              <th width={'20%'}>ねだん</th>
              <th width={'30%'}>うれた かず</th>
              <th width={'50%'}>もらった おかね</th>
            </tr>
          </thead>
          <tbody>{this._renderSales()}</tbody>
        </table>
      </div>
    );
  }

  _renderSales() {
    return this._getIceCtx().priceSalesData.map(data => {
      return (
        <tr key={data.price}>
          <td>{data.price}</td>
          <td>{data.num}</td>
          <td className={'coin-container'}>{this._renderCoin(data)}</td>
        </tr>
      );
    });
  }

  _renderCoin(data) {
    let coin5Num = Math.floor(data.coin / 5);
    let coin1Num = data.coin % 5;
    const PADDING = 10;
    let images = [];
    for (let i = 0; i < coin5Num; i++) {
      let style = {
        left: PADDING + i * 13,
      };
      images.push(
        <img
          key={`5-${i}-mobile`}
          style={style}
          src="../../images/pages/ice/fields/img-coin5.png"
          className={`coin-5 proc-mobile-and-tablet-only coin-order${i}`}
        />
      );
      style = {
        left: PADDING + i * 20,
      };
      images.push(
        <img
          key={`5-${i}-large`}
          style={style}
          src="../../images/pages/ice/fields/img-coin5.png"
          className={'coin-5 proc-large-pc-only'}
        />
      );
    }
    for (let i = 0; i < coin1Num; i++) {
      let style = {
        left: PADDING + coin5Num * 13 + i * 3,
      };
      images.push(
        <img
          key={`1-${i}-mobile`}
          style={style}
          src="../../images/pages/ice/fields/img-coin1.png"
          className={'coin-1 proc-mobile-and-tablet-only'}
        />
      );
      style = {
        left: PADDING + coin5Num * 20 + i * 3,
      };
      images.push(
        <img
          key={`1-${i}-large`}
          style={style}
          src="../../images/pages/ice/fields/img-coin1.png"
          className={'coin-1 proc-large-pc-only'}
        />
      );
    }
    return <React.Fragment>{images}</React.Fragment>;
  }

  _getIceCtx() {
    return this.props.iceCtxs[this.state.iceCtxIndex];
  }

  _onChangeIndex() {
    this.setState({ iceCtxIndex: this.state.iceCtxIndex === 0 ? 1 : 0 });
  }
}

AnalysisContent.propTypes = {
  wagon: PropTypes.number,
  iceCtxs: PropTypes.array,
  iceCtxIndex: PropTypes.number,
  title: PropTypes.string,
  onNextClick: PropTypes.func,
  onPreviousClick: PropTypes.func,
  lastPage: PropTypes.bool,
  research: PropTypes.bool,
};

AnalysisContent.defaultProps = {
  lastPage: false,
  research: false,
};
